package com.sweetlime.dungeonamigo.model

enum class DiceType(val sides: Int, val label: String, val emoji: String) {
    D4(4, "d4", "🔷"),
    D6(6, "d6", "⬜"),
    D8(8, "d8", "🔸"),
    D10(10, "d10", "🔹"),
    D12(12, "d12", "🟣"),
    D20(20, "d20", "⚪"),
    D100(100, "d100", "🟡")
}

data class SingleRoll(
    val diceType: DiceType,
    val result: Int,
    val isDropped: Boolean = false,
)

data class DiceRoll(
    val dice: List<SingleRoll>,
    val modifier: Int = 0,
    val label: String = "",
    val isAdvantage: Boolean = false,
    val isDisadvantage: Boolean = false,
    val timestamp: Long = 0,
) {
    val total: Int
        get() = dice.filter { !it.isDropped }.sumOf { it.result } + modifier

    val displayString: String
        get() {
            val groups = dice.filter { !it.isDropped }.groupBy { it.diceType }
            val expr = if (groups.isEmpty()) "—"
            else groups.entries.joinToString("+") { (type, rolls) -> "${rolls.size}${type.label}" }
            val modStr = when {
                modifier > 0 -> "+$modifier"
                modifier < 0 -> "$modifier"
                else -> ""
            }
            return "$expr$modStr = $total"
        }

    val isCrit: Boolean
        get() = dice.any { it.diceType == DiceType.D20 && it.result == 20 && !it.isDropped }

    val isCritFail: Boolean
        get() = dice.any { it.diceType == DiceType.D20 && it.result == 1 && !it.isDropped }
}
